(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    observer.unobserve(productRecommendationsSection);
    
    const url = productRecommendationsSection.dataset.url;
    
    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
        
        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          $('.CollectionProducts__Wrapper').slick(
            {
              "slidesToShow": 4,
              "slidesToScroll": 1,
              "infinite": true,
              "arrows": false,
              "dots": false,
              "fade": false,
              "accessibility": true,
              "speed": 600,
              "cssEase": "cubic-bezier(0, 0.07, 0.71, 1.02)",
              "responsive": [
                {
                  "breakpoint": 1200,
                  "settings": {
                    "arrows": false,
                    "dots": true,
                    "slidesToShow": 3
                  }
                },
                  {
                    "breakpoint": 750,
                    "settings": {
                      "arrows": false,
                      "dots": true,
                      "slidesToShow": 2
                    }
                  },
                {
                  "breakpoint": 480,
                  "settings": {
                    "arrows": false,
                    "dots": true,
                    "slidesToShow": 1
                  }
                }
              ]
            }
          );
        }
    })
    .catch(e => {
      console.error(e);
    });
  };
  
  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

observer.observe(productRecommendationsSection);


  } catch(e) { console.error(e); }
})();
})();
